import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Keyboard } from "@capacitor/keyboard";
import { initOta } from "./ota";

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // "ios" | "android" | "web"

export const initialiseNative = async () => {
  if (!isNative) return;
  // @capacitor/app is native-only — import lazily so it never lands in the web bundle.
  const { App: CapApp } = await import("@capacitor/app");
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#0E0F11" });
    // make the WebView extend under the status bar — the SPA respects safe-area-inset-top
    await StatusBar.setOverlaysWebView({ overlay: true });
  } catch {}
  try {
    Keyboard.setAccessoryBarVisible({ isVisible: false }).catch(() => {});
  } catch {}

  // hardware back: let Ionic handle by default; only intercept the root
  CapApp.addListener("backButton", ({ canGoBack }) => {
    if (!canGoBack) CapApp.exitApp();
  });

  // OTA — best-effort, never blocks UI
  initOta().catch(() => {});

  // deep links — invite codes, chain ids, etc.
  CapApp.addListener("appUrlOpen", (event) => {
    const url = new URL(event.url);
    // route examples:
    //   yelo://chain/<id>
    //   yelo://crew/<code>
    if (url.protocol === "yelo:") {
      const [_, kind, value] = url.pathname.split("/");
      // dispatch via window event so the React app can react
      window.dispatchEvent(new CustomEvent("yelo:deeplink", { detail: { kind, value } }));
    }
  });
};
